let options = {
  platforms: {
    statistics: false,
    overview: true,
    cost: true,
    'fraud-prevention': true,
    cohorts: true
  },
  osNames: {
    statistics: false,
    overview: true,
    cost: true,
    'fraud-prevention': true,
    cohorts: true
  },
  regions: {
    statistics: false,
    overview: true,
    cost: true,
    'fraud-prevention': true,
    cohorts: true
  },
  countries: {
    statistics: false,
    overview: true,
    cost: true,
    'fraud-prevention': true,
    cohorts: true
  },
  sandbox: {
    statistics: false,
    overview: true,
    cost: true,
    'fraud-prevention': true,
    cohorts: false
  },
  impression: {
    statistics: false,
    overview: true,
    cost: true,
    'fraud-prevention': true,
    cohorts: true
  },
  rejected: {
    statistics: false,
    overview: true,
    cost: true,
    'fraud-prevention': true,
    cohorts: false
  },
  cohorts: {
    statistics: false,
    overview: false,
    cost: false,
    'fraud-prevention': false,
    cohorts: true
  },
  grouping: {
    statistics: true,
    overview: true,
    cost: true,
    'fraud-prevention': true,
    cohorts: true
  },
  partners: {
    statistics: false,
    overview: true,
    cost: true,
    'fraud-prevention': true,
    cohorts: true
  },
  conversion_type: {
    statistics: false,
    overview: true,
    cost: true,
    'fraud-prevention': true,
    cohorts: true
  },
  attribution_source: {
    statistics: false,
    overview: true,
    cost: true,
    'fraud-prevention': true,
    cohorts: true
  },
  timezone: {
    statistics: true,
    overview: true,
    cost: true,
    'fraud-prevention': true,
    cohorts: true
  }
};

export { options };
